<template>
<div id="pay-ussd" class="opt-content-wrapper pay-pane active">

    <div class="modal-body text-center mb-4">
        <!--h1 style="color: grey; width: 100%;">{{ data.option }}</-h1-->
        <img :src="item.image_url" class="provider-logo" alt="" style="width: 20%; height :auto" />
        <h4 style="color: grey; width: 100%;" class="mt-3">Coming Soon</h4>
        <p class="mt-3 mb-5" style="font-size:14px;"> <strong>{{item.option}}</strong> is under development, please use other payment method.</p>
    </div>

    <div class="col-12 px-0 mt-4 text-center">
        <a href="javascript:void(0)" class="change-option" @click.prevent="changePaymentOption"> &larr; Choose another method </a>
    </div>
</div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'ComingSoon',
    props: ['data', 'client_info'],

    computed:{
        item(){
            return this.data.details;
        }
    },
    mounted() {
        // console.log(this.data);
    },
    methods: {
        changePaymentOption() {
            this.$parent.changeComponent("PaymentOptions");
        },
    },
}
</script>
